import { useMemo } from "react";
import { TPropertyStatus } from "../../typos/properties";
import { PropertyStatusLabel } from "../../enum/properties";

export interface IPropertyStatusTagProps {
  status: TPropertyStatus;
}

export function PropertyStatusTag({ status }: IPropertyStatusTagProps) {
  const style = useMemo(() => {
    switch (status) {
      case "WAITING_FOR_APPROVAL":
        return "bg-[#FFF7D6] text-[#A28201]";
      case "ACTIVE":
        return "bg-[#D6FFE7] text-[#018736]";
      case "PAUSED_BY_USER":
        return "bg-red-100 text-red-500";
      case "PAUSED_BY_APPLICATION":
        return "bg-[#EBEBEB] text-secondary";
      default:
        return "bg-gray-200 text-secondary";
    }
  }, [status]);

  return (
    <div className="flex items-center">
      <div
        className={`px-4 text-[13px] whitespace-nowrap leading-none py-2 inline-flex rounded-3xl overflow-hidden ${style}`}
      >
        {PropertyStatusLabel[status]}
      </div>
    </div>
  );
}
